module.exports = __webpack_public_path__ + "media/s2Part1Model1.56c0fc08.mp4";